import React from "react";
import { Box, Typography, CardContent } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { AcademicPerformanceStatsDto } from "../../../shared/dtos/academicYear/AcademicPerformanceStatsDto";

interface AcademicPerformanceWidgetProps {
  data: AcademicPerformanceStatsDto;
}

const AcademicPerformanceWidget: React.FC<AcademicPerformanceWidgetProps> = ({
  data,
}) => {
  const meta = getEntityMeta("REPORT_CARD");
  const Icon = meta.icon;
  const trendData = data?.performanceTrend || [];

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        {trendData.length > 0 ? (
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: 200 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={trendData}
                margin={{ top: 5, right: 20, left: -20, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="assessmentType" tick={{ fontSize: 12 }} />
                <YAxis domain={[0, 100]} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="avgScore"
                  stroke={meta.color}
                  strokeWidth={3}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              minHeight: 200,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontStyle: "italic" }}
            >
              No performance data available for this term yet.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default AcademicPerformanceWidget;
